<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-gas-pump" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Consumo de Combustible</h1>
		</div>
	</div>
</div>
<mat-card class="mt-2">
	<mat-card-content class="card-content">
		<div class="row">
			<div class="col-md-12">
				<h4 *ngIf="this.vehiculo">Ecónomico: {{this.vehiculo}}</h4>
				<span>A continuación se presenta la evolución del consumo de combustible.</span>
				<button id="boton" style="margin-top: -25px;" type="submit" class="btn btn-success float-right" (click)="imprimirPdf()">
					<i class="fal fa-file-pdf"></i>Generar PDF
				</button>&nbsp;
			</div>
		</div>
		
		<div id="grafica" class="row mt-3">
			<div  class="col col-sm-12 col-md-12 col-lg-12 mt-3">
				<dx-chart id="chart" [dataSource]="this.datos">
					<dxi-series argumentField="fecha" valueField="combustible" name="Combustible" type="line"
						color="#83B9ED">
					</dxi-series>
					<dxi-value-axis>
						<dxo-label [customizeText]="customizeText" [visible]="true" >
						</dxo-label>
					</dxi-value-axis>
					<dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
					<dxo-legend [margin]="1" horizontalAlignment="right" verticalAlignment="top"></dxo-legend>
					<dxo-loading-indicator [enabled]="true"></dxo-loading-indicator>
					<dxo-tooltip [enabled]="true" [shared]="true" argumentFormat="shortDateShortTime" contentTemplate="tooltipTemplate" container="#grafica"></dxo-tooltip>
					<div *dxTemplate="let info of 'tooltipTemplate'">
						<div class="pointInfo">
							<span>Combustible</span>: {{ info.point.data.combustible }} L&nbsp;&nbsp;&nbsp;&nbsp;<span>Velocidad</span>: {{ info.point.data.velocidad }} km/h
						</div>
						<div class="pointInfo" style="align-items: center; text-align: center;">
							<span>Fecha</span>: {{ info.point.data.fecha }}
						</div>
					</div>
				</dx-chart>
			</div>
		</div>
	</mat-card-content>
</mat-card>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false" message='Cargando...'>
</dx-load-panel>